// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base container styles */
.exam-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
}

/* Typography */
h1.exam-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.exam-description {
  color: #4b5563;
  margin-bottom: 2rem;
}

h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

/* Timer */
.timer {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  background-color: #e7f0ff;
  border-radius: 0.5rem;
  color: #2563eb;
  font-weight: 500;
  margin-bottom: 1.5rem;
  width: fit-content;
}

.timer span {
  margin-left: 0.5rem;
}

/* Loading state */
.exam-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
}

.spinner {
  width: 3rem;
  height: 3rem;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Error state */
.exam-error {
  text-align: center;
  color: #ef4444;
  padding: 2rem;
  background-color: #fef2f2;
  border-radius: 0.5rem;
  margin: 2rem 0;
}

.retry-button {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
}

/* Questions container */
.exam-questions {
  margin-bottom: 2rem;
}

/* Question styles */
.question {
  background-color: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.answers {
  margin-top: 0.75rem;
}

.answer {
  margin-bottom: 0.75rem;
}

.answer label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.answer input[type="radio"] {
  margin-right: 0.75rem;
}

/* Matching questions */
.matching-section {
  margin-top: 2rem;
}

.matching-question {
  background-color: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.matching-options {
  margin-top: 1rem;
}

.matching-pair {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.pair-prompt {
  font-weight: 500;
  margin-right: 1rem;
  min-width: 150px;
}

.matching-pair select {
  flex-grow: 1;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background-color: #fff;
}

/* Button styles */
/* Button container for questions screen */
.button-container {
  display: flex;
  justify-content: flex-end; /* Aligns buttons to the right */
  margin-top: 2rem;
  gap: 1rem; /* Creates space between adjacent buttons */
  position: relative; /* Added for positioning context */
}

.next-button, .submit-button, .back-button {
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.next-button {
  background-color: #3b82f6;
  color: white;
}

.next-button:hover {
  background-color: #2563eb;
}

.submit-button {
  background-color: #059669;
  color: white;
}

.submit-button:hover {
  background-color: #047857;
}

/* Back button styles for questions screen */
.back-button {
  background-color: #4776E6;
  color: white;
  padding: 1rem 4rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.back-button:hover {
  background-color: #2563eb;
}

/* Results screen */
.exam-result {
  background-color: white;
  border-radius: 0.5rem;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.exam-result h2 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.exam-result p {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
}

.passed {
  color: #10b981;
  font-weight: 600;
}

.failed {
  color: #ef4444;
  font-weight: 600;
}

/* Special styling for back button on the results screen */
.exam-result .back-button {
  position: static;
  margin: 2rem;
  color: white;
  background-color: #4776E6;
  padding: 0.75rem 2rem; /* Reduced padding to fit content better */
  font-size: 1rem;
 
  
 
  white-space: nowrap; 
  display: inline-block; 
  text-align: center; 
  width: auto; /* Allows the button to expand based on content */
  min-width: 150px; /* Ensures minimum width to fit "Back to Exams" */
}

/* Responsive styles */
@media (max-width: 768px) {
  .exam-container {
    padding: 1rem;
  }
  
  .matching-pair {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .pair-prompt {
    margin-bottom: 0.5rem;
    margin-right: 0;
  }
  
  .matching-pair select {
    width: 100%;
  }
  
  /* Stack buttons on mobile but keep their order */
  .button-container {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  
  /* For mobile view on questions screen, reposition the back button */
  .button-container .back-button {
    position: static;
    order: -1; /* Makes it appear first in the column */
  }
  
  .back-button, .next-button, .submit-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Exams/StartExam.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB,0CAA0C;AAC1C;EACE,aAAa;EACb,yBAAyB,EAAE,gCAAgC;EAC3D,gBAAgB;EAChB,SAAS,EAAE,2CAA2C;EACtD,kBAAkB,EAAE,kCAAkC;AACxD;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,qBAAqB,EAAE,0CAA0C;EACjE,eAAe;;;;EAIf,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW,EAAE,iDAAiD;EAC9D,gBAAgB,EAAE,iDAAiD;AACrE;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA,iDAAiD;EACjD;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA,oEAAoE;EACpE;IACE,gBAAgB;IAChB,SAAS,EAAE,wCAAwC;EACrD;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Base container styles */\r\n.exam-container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 1.5rem;\r\n}\r\n\r\n/* Typography */\r\nh1.exam-title {\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.exam-description {\r\n  color: #4b5563;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\nh2 {\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\nh3 {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n/* Timer */\r\n.timer {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0.75rem;\r\n  background-color: #e7f0ff;\r\n  border-radius: 0.5rem;\r\n  color: #2563eb;\r\n  font-weight: 500;\r\n  margin-bottom: 1.5rem;\r\n  width: fit-content;\r\n}\r\n\r\n.timer span {\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n/* Loading state */\r\n.exam-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 50vh;\r\n}\r\n\r\n.spinner {\r\n  width: 3rem;\r\n  height: 3rem;\r\n  border: 4px solid rgba(0, 0, 0, 0.1);\r\n  border-left-color: #3b82f6;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n/* Error state */\r\n.exam-error {\r\n  text-align: center;\r\n  color: #ef4444;\r\n  padding: 2rem;\r\n  background-color: #fef2f2;\r\n  border-radius: 0.5rem;\r\n  margin: 2rem 0;\r\n}\r\n\r\n.retry-button {\r\n  margin-top: 1rem;\r\n  padding: 0.5rem 1rem;\r\n  background-color: #ef4444;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 0.5rem;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Questions container */\r\n.exam-questions {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n/* Question styles */\r\n.question {\r\n  background-color: white;\r\n  border-radius: 0.5rem;\r\n  padding: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.answers {\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.answer {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.answer label {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.answer input[type=\"radio\"] {\r\n  margin-right: 0.75rem;\r\n}\r\n\r\n/* Matching questions */\r\n.matching-section {\r\n  margin-top: 2rem;\r\n}\r\n\r\n.matching-question {\r\n  background-color: white;\r\n  border-radius: 0.5rem;\r\n  padding: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.matching-options {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.matching-pair {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.pair-prompt {\r\n  font-weight: 500;\r\n  margin-right: 1rem;\r\n  min-width: 150px;\r\n}\r\n\r\n.matching-pair select {\r\n  flex-grow: 1;\r\n  padding: 0.5rem;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 0.375rem;\r\n  background-color: #fff;\r\n}\r\n\r\n/* Button styles */\r\n/* Button container for questions screen */\r\n.button-container {\r\n  display: flex;\r\n  justify-content: flex-end; /* Aligns buttons to the right */\r\n  margin-top: 2rem;\r\n  gap: 1rem; /* Creates space between adjacent buttons */\r\n  position: relative; /* Added for positioning context */\r\n}\r\n\r\n.next-button, .submit-button, .back-button {\r\n  padding: 0.75rem 1.5rem;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  border: none;\r\n  border-radius: 0.5rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.next-button {\r\n  background-color: #3b82f6;\r\n  color: white;\r\n}\r\n\r\n.next-button:hover {\r\n  background-color: #2563eb;\r\n}\r\n\r\n.submit-button {\r\n  background-color: #059669;\r\n  color: white;\r\n}\r\n\r\n.submit-button:hover {\r\n  background-color: #047857;\r\n}\r\n\r\n/* Back button styles for questions screen */\r\n.back-button {\r\n  background-color: #4776E6;\r\n  color: white;\r\n  padding: 1rem 4rem;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  border: none;\r\n  border-radius: 0.5rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.back-button:hover {\r\n  background-color: #2563eb;\r\n}\r\n\r\n/* Results screen */\r\n.exam-result {\r\n  background-color: white;\r\n  border-radius: 0.5rem;\r\n  padding: 2rem;\r\n  text-align: center;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.exam-result h2 {\r\n  font-size: 1.5rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.exam-result p {\r\n  font-size: 1.25rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.passed {\r\n  color: #10b981;\r\n  font-weight: 600;\r\n}\r\n\r\n.failed {\r\n  color: #ef4444;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Special styling for back button on the results screen */\r\n.exam-result .back-button {\r\n  position: static;\r\n  margin: 2rem;\r\n  color: white;\r\n  background-color: #4776E6;\r\n  padding: 0.75rem 2rem; /* Reduced padding to fit content better */\r\n  font-size: 1rem;\r\n \r\n  \r\n \r\n  white-space: nowrap; \r\n  display: inline-block; \r\n  text-align: center; \r\n  width: auto; /* Allows the button to expand based on content */\r\n  min-width: 150px; /* Ensures minimum width to fit \"Back to Exams\" */\r\n}\r\n\r\n/* Responsive styles */\r\n@media (max-width: 768px) {\r\n  .exam-container {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .matching-pair {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .pair-prompt {\r\n    margin-bottom: 0.5rem;\r\n    margin-right: 0;\r\n  }\r\n  \r\n  .matching-pair select {\r\n    width: 100%;\r\n  }\r\n  \r\n  /* Stack buttons on mobile but keep their order */\r\n  .button-container {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    align-items: stretch;\r\n  }\r\n  \r\n  /* For mobile view on questions screen, reposition the back button */\r\n  .button-container .back-button {\r\n    position: static;\r\n    order: -1; /* Makes it appear first in the column */\r\n  }\r\n  \r\n  .back-button, .next-button, .submit-button {\r\n    width: 100%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
